import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Massage Party',
    href: '#massage-party'
  }, {
    name: 'Staff',
    href: '#staff'
  }, {
    name: 'Facilities',
    href: '#facilities'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-plum-950/90 backdrop-blur-md py-4 border-b border-lavender-400/10' : 'bg-transparent py-6'}`} data-id="element-239">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-240">
        <a href="#" className="font-serif text-3xl tracking-widest text-lavender-50 hover:text-lavender-300 transition-colors" data-id="element-241">
          AFRIEL
        </a>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-242">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm uppercase tracking-widest text-lavender-100/70 hover:text-lavender-300 transition-colors" data-id="element-243">
              {link.name}
            </a>)}
          <a href="#reservations" className="px-6 py-2 bg-gradient-to-r from-lavender-500 to-rose-500 text-white text-sm uppercase tracking-widest hover:from-lavender-600 hover:to-rose-500 transition-all duration-300 rounded-full shadow-lg shadow-lavender-500/30" data-id="element-244">
            Book Now
          </a>
        </nav>

        <button className="md:hidden text-lavender-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-245">
          {isMobileMenuOpen ? <X size={28} data-id="element-246" /> : <Menu size={28} data-id="element-247" />}
        </button>
      </div>

      <AnimatePresence data-id="element-248">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-plum-950 border-b border-lavender-400/10 md:hidden" data-id="element-249">
            <div className="flex flex-col px-6 py-8 space-y-6" data-id="element-250">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg uppercase tracking-widest text-lavender-100/80 hover:text-lavender-300" data-id="element-251">
                  {link.name}
                </a>)}
              <a href="#reservations" onClick={() => setIsMobileMenuOpen(false)} className="inline-block text-center px-6 py-3 bg-gradient-to-r from-lavender-500 to-rose-500 text-white text-sm uppercase tracking-widest rounded-full" data-id="element-252">
                Book Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}